function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs830"
}, /*#__PURE__*/React.createElement("clipPath", {
  id: "tv-a"
}, /*#__PURE__*/React.createElement("path", {
  id: "path827",
  fillOpacity: 0.7,
  d: "M0 0h640v480H0z"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "rect891",
  fill: "#009fca",
  fillOpacity: 1,
  strokeWidth: 11.8,
  d: "M0 0h640v480H0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "path862",
  fill: "#fff40d",
  fillRule: "evenodd",
  strokeWidth: "1pt",
  d: "M593.3 122.7H621l-22.3 15.2 8.5 24.7-22.3-15.3-22.2 15.3 8.5-24.7-22.3-15.2h27.5l8.5-24.7zm-69.2 196.8h27.6l-22.3 15.2 8.5 24.7-22.3-15.3-22.3 15.3 8.6-24.7-22.3-15.2H507l8.5-24.7zm69.2-44.6H621l-22.3 15.2 8.5 24.7-22.3-15.3-22.2 15.3 8.5-24.7-22.3-15.2h27.5l8.5-24.7zM295.8 417.7h27.6L301 432.8l8.6 24.6-22.3-15.2-22.3 15.2 8.6-24.6-22.4-15.3h27.6l8.5-24.6zm62.6-76.5h-27.6l22.3-15.3-8.5-24.6 22.3 15.2 22.3-15.2-8.6 24.6 22.3 15.3h-27.5l-8.5 24.6zm81.3-112.5H412l22.3-15.2-8.5-24.7 22.3 15.3 22.3-15.3-8.6 24.7 22.3 15.2h-27.5l-8.5 24.7zm68.3-23.3h-27.6l22.4-15.3-8.6-24.6 22.3 15.2 22.3-15.2-8.6 24.6 22.4 15.3H525l-8.5 24.6zM439.7 400H412l22.3-15.2L426 360l22.3 15.2 22.3-15.2-8.6 24.7 22.3 15.2h-27.5l-8.5 24.7zm-81.3 19.9h-27.6l22.3-15.2-8.5-24.7 22.3 15.2 22.3-15.2-8.6 24.6L403 420h-27.5l-8.5 24.7z",
  opacity: 1,
  stopOpacity: 1
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "g1551",
  transform: "scale(.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1529",
  fill: "#012169",
  d: "M0 0h640v480H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1531",
  fill: "#FFF",
  d: "m75 0 244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1533",
  fill: "#C8102E",
  d: "m424 281 216 159v40L369 281zm-184 20 6 35L54 480H0zM640 0v3L391 191l2-44L590 0zM0 0l239 176h-60L0 42z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1535",
  fill: "#FFF",
  d: "M241 0v480h160V0zM0 160v160h640V160z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1537",
  fill: "#C8102E",
  d: "M0 193v96h640v-96zM273 0v480h96V0z"
}));

var SvgTv = function SvgTv(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flag-icons-tv",
    viewBox: "0 0 640 480",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTv, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tv.170f9453.svg";
export { ForwardRef as ReactComponent };